import { pipelineGreenLegend } from '../config/legends'

const service = {
    name: 'Pipeline',
    label: 'Pipeline',
    permissionId: 'pipeline',
    iconComponent: 'Pipeline',
    showCoordinates: true,
    hideDatetimeSlider: true,
    data: [],
    layers: [
      {
        name: 'PipelineGreen',
        label: 'Pipeline Green',
        opacity: 'raster-opacity',
        datetimeId: 'PipelineGreen',
        open: true,
        legend: {
          type: 'categorical',
          data: pipelineGreenLegend
        }
      },
      {
        name: 'Sentinel2EnbridgePipeline',
        label: 'Enbridge Pipeline',
        opacity: 'vector-opacity',
        datetimeId: 'PipelineGreen',
        hidden: true
      },
      // {
      //   name: 'PlanetLabs',
      //   label: 'Aerial imagery',
      //   opacity: 'raster-opacity',
      // }
    ],
    locations: [
      {
        name: 'Quebec',
        label: 'Quebec',
        latitude: 48.282,
        longitude: -72.186,
        maxBounds: [[-150, -85], [80, 85]],
        zoom: [10]
      },
      {
        name: 'Yoloten',
        label: 'Yoloten',
        latitude: 37.295186,
        longitude: 62.367123,
        zoom: [10]
      },
      {
        name: 'Towgrondi',
        label: 'Towgrondi',
        latitude: 35.262545,
        longitude: 62.283,
        zoom: [10]
      },
      {
        name: 'Herat',
        label: 'Herat',
        latitude: 34.359384,
        longitude: 62.203823,
        zoom: [10]
      },
      {
        name: 'FarahRud',
        label: 'Farah Rud',
        latitude: 32.759368,
        longitude: 62.603716,
        zoom: [10]
      },
      {
        name: 'Kandahar',
        label: 'Kandahar',
        latitude: 31.746383,
        longitude: 65.713584,
        zoom: [10]
      },
      {
        name: 'SpinBuldak',
        label: 'Spin Buldak',
        latitude: 31.009862,
        longitude: 66.402439,
        zoom: [10]
      },
      {
        name: 'Quetta',
        label: 'Quetta',
        latitude: 30.310058,
        longitude: 66.922944,
        zoom: [10]
      },
      {
        name: 'Multan',
        label: 'Multan',
        latitude: 30.282975,
        longitude: 71.490179,
        zoom: [10]
      },
      {
        name: 'Sulemanki',
        label: 'Sulemanki',
        latitude: 30.385187,
        longitude: 73.851376,
        zoom: [10]
      },
      {
        name: 'Fazika',
        label: 'Fazika',
        latitude: 30.549155,
        longitude: 74.027290,
        zoom: [10]
      },
      {
        name: 'MackinawCity',
        label: 'Mackinaw City',
        latitude: 45.783889,
        longitude: -84.7278,
        maxBounds: [[-150, -85], [80, 85]],
        zoom: [10]
      },
    ]
  }

export default service



// WEBPACK FOOTER //
// ./src/services/Pipeline.js